exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.space-y-2[data-v-b38a1fd0] > * + * {\n  margin-top: 0.5rem;\n}\n\n/* Custom scrolling for long lists */\nul[data-v-b38a1fd0],\nol[data-v-b38a1fd0] {\n  max-height: var(--v0d0f1b90);\n  overflow-y: auto;\n}\n", ""]);

// exports
